import { loginUrl } from "@/lib/session";

/**
 * The signed-out screen.
 *
 * Reached only when the automatic bounce has already been tried once this tab — the normal
 * experience is that you never see this, because boot redirects straight to Google. It exists so a
 * redirect loop turns into a readable page instead of a browser fighting itself.
 */
export function SignIn({ reason }: { reason?: string | null }) {
  return (
    <div className="flex h-full flex-1 items-center justify-center bg-void p-10">
      <div className="max-w-[420px] text-center">
        <div aria-hidden className="font-jp text-[46px]/[1] text-ink-off">
          読
        </div>
        <h1 className="mt-4 text-title font-semibold text-ink">Nihongonator</h1>
        <p className="mt-2 text-secondary text-ink-3">
          {reason ?? "このコレクションは非公開です。続けるにはサインインしてください。"}
        </p>
        <a
          href={loginUrl()}
          className="mt-5 inline-block rounded-[var(--r-2)] bg-accent px-[15px] py-[10px] text-[15px]/[1] font-semibold text-white"
        >
          Google でサインイン
        </a>
      </div>
    </div>
  );
}
